import {Card, CardContent, CardHeader, Divider} from '@mui/material';
import {bool, node, string} from 'prop-types';
import React from 'react';

const DrawerHeader = ({
  avatar,
  children,
  contentDivider,
  subHeader,
  title,
  'data-tour': tourId,
  ...props
}) => {
  return (
    <>
      <Card
        elevation={2}
        square
        sx={theme => ({
          overflow: 'visible',
          ...theme.applyStyles('light', {
            backgroundColor: 'grey.100',
          }),
          boxShadow: 'none',
        })}
        data-tour={tourId}
      >
        <CardHeader
          avatar={avatar}
          title={title}
          subheader={subHeader}
          titleTypographyProps={{
            variant: 'h6',
            component: 'h2',
            fontWeight: 500,
            noWrap: true,
            title: title,
          }}
          sx={{
            paddingBlockStart: 1,
            paddingBlockEnd: 1,
            '& .MuiCardHeader-avatar': {
              color: 'action.active',
            },
            '& .MuiCardHeader-content': {
              width: '100%',
              overflow: 'hidden',
              alignSelf: 'center',
              display: 'flex',
              alignItems: 'center',
              height: 40,
            },
            '& .MuiCardHeader-action': {
              marginLeft: 0.5,
              alignSelf: 'center',
            },
          }}
          {...props}
        />
        {children && (
          <>
            {contentDivider && <Divider sx={{marginBottom: 1}} />}
            <CardContent
              sx={{
                paddingTop: 0,
                ':last-child': {
                  paddingBottom: 2,
                },
              }}
            >
              {children}
            </CardContent>
          </>
        )}
      </Card>
      <Divider />
    </>
  );
};

DrawerHeader.propTypes = {
  action: node,
  avatar: node,
  children: node,
  contentDivider: bool,
  subHeader: node,
  title: node,
  'data-tour': string,
};

export default DrawerHeader;
